<div style="display: block; text-align: center; min-height: 60%;">
    <p style="font-size: 80px; margin-left: 2.5%; margin-right: 2.5%;">
        NO TICKETS AVAILABLE AT THIS TIME
    </p>
    <!--x
    <div class="tourRow">
        <p class="tourText"> Tour Date and Location to be announced</p>
        <button (click)="openTour('https://www.google.com')" class="tourButton">Tickets</button>
    </div>-->
</div>